import script from "./ReceivedView.vue?vue&type=script&setup=true&lang=js"
export * from "./ReceivedView.vue?vue&type=script&setup=true&lang=js"

import "./ReceivedView.vue?vue&type=style&index=0&id=3eb93973&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eb93973"]])

export default __exports__